import React, { FunctionComponent } from 'react';
import { StyleProp, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';
import { defaultScale } from '../../utils/scaling';
import { horizontalScrollConstants } from './HorizontalScroller';

interface IProps {
  children: React.ReactNode;
  onPress: () => any;
  style: StyleProp<ViewStyle>;
  lastCard: boolean;
  wideCard?: boolean;
}

export const HorizontalScrollerCard: FunctionComponent<IProps> = ({
                                                                    children,
                                                                    style,
                                                                    onPress,
                                                                    lastCard,
                                                                    wideCard = false,
                                                                  }) => {

  const addMarginRightToLastCard = lastCard && !wideCard;

  return (
    <TouchableOpacity onPress={onPress} style={[
      styles.card,
      wideCard && { width: horizontalScrollConstants.CARD_WIDTH_WIDE },
      addMarginRightToLastCard && { marginRight: horizontalScrollConstants.CARD_MARGIN },
      style,
    ]}>
      {children}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  card: {
    flex: 1,
    borderRadius: horizontalScrollConstants.CARD_BOARDER_RADIUS,
    overflow: 'hidden',
    width: horizontalScrollConstants.CARD_WIDTH,
    marginLeft: horizontalScrollConstants.CARD_MARGIN,
  },
})